import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DetectBrowserService {
  getBrowserNameAndVersion() {
    const ua = navigator.userAgent;
    let tem: string[],
      M =
        RegExp(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ).exec(ua) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return { name: 'IE', version: tem[1] || '' };
    }
    if (M[1] === 'Chrome') {
      tem = RegExp(/\bEdg\/(\d+)/).exec(ua);
      if (tem != null) {
        return { name: 'Edge(Chromium)', version: tem[1] };
      }
      tem = RegExp(/\bOPR\/(\d+)/).exec(ua);
      if (tem != null) {
        return { name: 'Opera', version: tem[1] };
      }
    }
    const M2 = M[2]
      ? [M[1], M[2]]
      : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = RegExp(/version\/(\d+)/i).exec(ua)) != null) {
      M2.splice(1, 1, tem[1]);
    }
    return {
      name: M2[0],
      version: M2[1]
    };
  }
}
